<template>
  <label class="n-checkbox" :class="{'is-checked':isChecked}" @click="handleClick">
    <span class="n-checkbox__input" :class="{'is-checked':isChecked}">
      <span class="n-checkbox__inner" :class="{'is-checked':isChecked}"></span>
      <input type="checkbox" class="n-checkbox__original" 
      :name="name"
      v-on:change="handleChange"  v-bind:checked="checked" />
    </span>
    <span><slot></slot></span>
  </label>
</template>

<script>
export default {
  model:{
    prop:'checked',
    event:'change'
  },
  props:{
    checked:Boolean,
    name:""
  },

  watch: {
    checked(val){
      this.isChecked = val
    }
  },
  data() {
    return {
      isChecked:this.checked
    }
  },
  methods: {
    handleClick(){
      this.isChecked =!this.isChecked
      this.$emit('click',this.isChecked)
    },
    handleChange(){
      this.$emit('change',this.isChecked)
    }
  },
}
</script>

<style lang="scss" scoped>
.n-checkbox {
  color: #606266;
  font-weight: 500;
  font-size: 14px;
  position: relative;
  cursor: pointer;
  display: inline-block;
  white-space: nowrap;
  user-select: none;
  margin-right: 20px;
}
.n-checkbox__input {
  // margin-right: 6px;
  vertical-align: middle;

}
.n-checkbox__inner {
  width: 20px;
  height: 20px;
  display: inline-block;
  border: 1px solid #888;
  border-radius: 50%;
  position: relative;
}
.n-checkbox__inner::after {
  box-sizing: content-box;
  content: '';
  border: 2px solid $primaryColor;
  border-left: 0;
  border-top: 0;
  height: 8px;
  left: 6px;
  position: absolute;
  top: 2px;
  transform: rotate(45deg) scaleY(0);
  width: 4px;
  transition: all 0.15s ease-in 0.05s;
  transform-origin: center;
}
.n-checkbox__original {
  opacity: 0;
  position: absolute;
  top: 0;
  z-index: -1;
  width: 0;
}

.n-checkbox__input.is-checked .n-checkbox__inner:after {
  transform: rotate(45deg) scaleY(1);
}
.n-checkbox__inner.is-checked {
  border-color: $primaryColor;
}
</style>
